import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getPremiumStatusRequest = {};
var _getPremiumStatusResponse = {};
function resolveComWixpressMembershipV1PremiumPremiumServiceUrl(opts) {
    var domainToMappings = {
        'www._base_domain_': [
            {
                srcPath: '/_api/paid-plans',
                destPath: '',
            },
        ],
        'forums.wixapps.net': [
            {
                srcPath: '/_api/paid-plans',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/paid-plans',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/paid-plans',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/paid-plans',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/paid-plans',
                destPath: '',
            },
            {
                srcPath: '/paid-plans/v1/orders',
                destPath: '/v1/orders',
            },
        ],
        '*.wixapps.net': [
            {
                srcPath: '/_api/paid-plans',
                destPath: '',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/paid-plans',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/paid-plans',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/paid-plans',
                destPath: '',
            },
            {
                srcPath: '/_api/pricing-plans',
                destPath: '',
            },
        ],
        'forums._base_domain_': [
            {
                srcPath: '/_api/paid-plans',
                destPath: '',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/paid-plans',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/paid-plans',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/membership-api',
                destPath: '',
            },
            {
                srcPath: '/paid-plans',
                destPath: '',
            },
            {
                srcPath: '/_api/paid-plans',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Checks whether site has premium status, non-free plans and plans created before Pricing Plans became premium */
export function getPremiumStatus(payload) {
    var _a = serializer(_getPremiumStatusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPremiumStatusResponse, {}).fromJSON;
    function __getPremiumStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v1.premium_status',
            method: 'GET',
            methodFqn: 'com.wixpress.membership.v1.premium.PremiumService.GetPremiumStatus',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembershipV1PremiumPremiumServiceUrl({
                protoPath: '/v1/premium/status',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPremiumStatus.fromReq = fromReq;
    __getPremiumStatus.__isAmbassador = true;
    return __getPremiumStatus;
}
//# sourceMappingURL=http.impl.js.map